import { render } from "./CreateDependenciaReq.vue?vue&type=template&id=e3ba8066&scoped=true"
import script from "./CreateDependenciaReq.vue?vue&type=script&lang=js"
export * from "./CreateDependenciaReq.vue?vue&type=script&lang=js"

import "./CreateDependenciaReq.vue?vue&type=style&index=0&id=e3ba8066&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3ba8066"]])

export default __exports__